import DocsMenuSection from "../types/DocsMenuSection";


export default class DocsSectionUtils
{
    static loadedImages = {};

    static buildLeafUrlsFromMenu( menu: DocsMenuSection )
    {
        const menuSectionUrls: Array<string> = [];
        const menuSectionStack: Array<DocsMenuSection> = [ menu ];

        while ( menuSectionStack.length > 0 )
        {
            const menuSection: DocsMenuSection = ( menuSectionStack.pop() as DocsMenuSection );

            if ( menuSection.children.length > 0 )
            {
                Array.prototype.push.apply( menuSectionStack, menuSection.children );
            } else
            {
                menuSectionUrls.push( menuSection.url );
            }
        }

        return menuSectionUrls;
    }

    static buildHeaderUrlsFromMenu( menu: DocsMenuSection )
    {
        const menuSectionUrls: Array<string> = [];
        const menuSectionStack: Array<DocsMenuSection> = [ menu ];

        while ( menuSectionStack.length > 0 )
        {
            const menuSection: DocsMenuSection = ( menuSectionStack.pop() as DocsMenuSection );

            if ( menuSection.children.length > 0 )
            {
                menuSectionUrls.push( menuSection.url );
                Array.prototype.push.apply( menuSectionStack, menuSection.children );
            }
        }

        return menuSectionUrls;
    }

    static getActiveSection( url: string, menu: DocsMenuSection )
    {
        let bestMatch = '';
        let bestMatchLength = 0;

        const menuSectionUrls = DocsSectionUtils.buildLeafUrlsFromMenu( menu );

        for ( const menuSectionUrl of menuSectionUrls )
        {
            if ( url.indexOf( menuSectionUrl ) > -1 && menuSectionUrl.length > bestMatchLength )
            {
                bestMatch = menuSectionUrl;
                bestMatchLength = menuSectionUrl.length;
            }
        }

        return bestMatch;
    }

    static getOpenSection( url: string, menu: DocsMenuSection )
    {
        let bestMatch = '';
        let bestMatchLength = 0;

        const menuSectionUrls = DocsSectionUtils.buildHeaderUrlsFromMenu( menu );

        for ( const menuSectionUrl of menuSectionUrls )
        {
            if ( url.indexOf( menuSectionUrl ) > -1 && menuSectionUrl.length > bestMatchLength )
            {
                bestMatch = menuSectionUrl;
                bestMatchLength = menuSectionUrl.length;
            }
        }

        return bestMatch;
    }

    static findImage( id: string, isActive: boolean ): string | undefined
    {
        if ( !DocsSectionUtils.hasImage( id ) )
        {
            return undefined;
        }

        const allImages = DocsSectionUtils.loadedImages[ id ];
        const modifier = isActive ? 'active' : 'inactive';

        return allImages[ modifier ];
    }

    static hasImage( id: string ): boolean
    {
        return ( id !== "" ) && DocsSectionUtils.loadedImages.hasOwnProperty( id );
    }

    static loadTwoStateImage( id: string, imageName: string ): void
    {
        DocsSectionUtils.loadedImages[ id ] = {
            active: require( '../images/menu/active/' + imageName ),
            inactive: require( '../images/menu/inactive/' + imageName )
        };
    }

    static loadImages(): void
    {
        DocsSectionUtils.loadTwoStateImage( '_reporting', 'reporting_apis.svg' );
        DocsSectionUtils.loadTwoStateImage( '_integration', 'api.svg' );
        DocsSectionUtils.loadTwoStateImage( '_testing', 'magnifying_glass_gray.svg' );
        DocsSectionUtils.loadTwoStateImage( '_success', 'success.svg' );
        DocsSectionUtils.loadTwoStateImage( '_help_center', 'help.svg' );
        DocsSectionUtils.loadTwoStateImage( '_gdpr_deleted_device_ids_api', 'mediation_experiment.svg' );
        DocsSectionUtils.loadTwoStateImage( 'menu_arrow', 'menu_arrow.svg' );
    }
}

DocsSectionUtils.loadImages();

